import { FC, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Component from "./Component";

//Assets
import ScheduledIcon from "../../../../images/scheduled.png";

//Actions
import { getPickupTimeSlot, createPickupRequest } from "../../../../actions/shipperAction";

//Helpers
import { timeslotHelper, getTimezone } from "../../../../utils/Helpers";

//Interfaces
import { TimeslotType, WrapperInterface } from "./definitions"

const PickupScheduled: FC<WrapperInterface> = ({
  order_id,
  onBack,
  continueAction
}) => {
  const [loading, setLoading] = useState(true);
  const [timeslot, setTimeslot] = useState<any>(null);
  const [timezone] = useState(getTimezone());
  const [selectedDateCard, setSelectedDateCard] = useState<any>(null);
  const [selectedTime, setSelectedTime] = useState<TimeslotType>({
    start_time: "",
    end_time: "",
    start_hour: "",
    end_hour: "",
    key: ""
  });

  const createPickupRequestHandler = async () => {
    try {
      setLoading(true)
      const payload = {
        order_id: order_id,
        timezone: timezone,
        start_time: selectedTime.start_time,
        end_time: selectedTime.end_time
      }

      await createPickupRequest(payload)
        .then(res => res?.data)
        .then(res => {
          if (res.data) {
            const _timeslot = {
              start_time: res?.data?.pickup_start_time || selectedTime.start_time,
              end_time: res?.data?.pickup_end_time || selectedTime.end_time
            }
            localStorage.setItem(`${order_id}_TIMESLOT`, JSON.stringify(_timeslot))
            continueAction({
              ...res.data,
              start_time: selectedTime.start_time,
              end_time: selectedTime.end_time
            })
          }
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when create request pickup")
    }
  }

  const getPickupTimeSlotHandler = async () => {
    try {
      setLoading(true)
      await getPickupTimeSlot(timezone)
        .then(res => res?.data)
        .then(res => {
          if (res?.data?.time_slots?.length) {
            setTimeslot(timeslotHelper(res.data.time_slots))
          }
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })

    } catch (err) {
      setLoading(false)
      console.log(err, "Error when fetching timesslot, fn getPickupTimeSlotHandler file PickupSchedule.tsx")
    }
  }

  const selectDateHandler = (card) => {
    setSelectedDateCard(card)
    setSelectedTime({
      start_time: "",
      end_time: "",
      start_hour: "",
      end_hour: "",
      key: ""
    })
  }

  const cardListHandler = () => {
    if (!timeslot) return [];

    const slotArr = Object.keys(timeslot)

    if (!slotArr?.length) return null;

    const cardList: any = []

    for (let key in timeslot) {
      cardList.push({ ...timeslot[`${key}`], key })
    }

    return cardList
  }

  const selectTimeHandler = (time) => {
    setSelectedTime({ ...time, key: `${time?.start_time}${time?.end_time}` })
  }

  const isActiveTimeHandler = (time) => `${time?.start_time}${time?.end_time}` === selectedTime?.key;

  const isActiveCardHandler = (card) => selectedDateCard?.key === card.key;

  useEffect(() => {
    getPickupTimeSlotHandler()
  }, [])

  return (
    <Component
      loading={loading}
      selectedTime={selectedTime}
      cardList={cardListHandler()}
      timeslotList={selectedDateCard?.timeslot || []}
      timezone={timezone}
      onBack={onBack}
      isActiveCardHandler={isActiveCardHandler}
      isActiveTimeHandler={isActiveTimeHandler}
      selectTimeHandler={selectTimeHandler}
      selectDateHandler={selectDateHandler}
      createPickupRequestHandler={createPickupRequestHandler}
    />
  )
}
PickupScheduled.defaultProps = {
  onBack: () => { },
  continueAction: () => { }
}

export default PickupScheduled;